import { Box, Button, Card, Divider, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, stockParamsFormByStoreActions } from '../../redux/store'
import StockParamsByStoreForm from '../../components/StockParamsByStoreForm'
import LabelIcon from '@mui/icons-material/Label'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { DOMAIN } from '../../utils/api'
import { mainGreen, mainRed } from '../../utils/color'

export default function StockParameterByStore() {
	const { showParamsByStoreForm } = useSelector((state) => state.stockParamsByStoreForm)
	const { currentUser } = useSelector((state) => state.currentUser)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [subStock, setSubStock] = useState()

	const getSubStock = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/${currentUser.store}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setSubStock(response.data[0])
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, currentUser.store],
	)

	useEffect(() => {
		getSubStock()
	}, [getSubStock])

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
					padding: '10px',
				}}>
				<Card>
					<Box
						sx={{
							textAlign: 'right',
							display: 'flex',
							justifyContent: 'flex-end',
							background: mainGreen,
							padding: '2px 0',
						}}>
						<CloseIcon
							sx={{
								cursor: 'pointer',
								color: '#fff',
							}}
							onClick={() => {
								navigate('/store-manager/stock/fresh')
							}}
						/>
					</Box>
					<Divider />
					<Box
						sx={{
							padding: '10px',
						}}>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								mb: 2,
							}}>
							<h3 style={{ margin: 0 }}>THÔNG SỐ KHO</h3>
							<Button
								variant='contained'
								sx={{
									padding: '0 10px',
									textTransform: 'none',
									background: mainRed,
									'&:hover': { background: mainRed },
								}}
								size='small'
								onClick={() => {
									dispatch(
										stockParamsFormByStoreActions.stockParams({
											maxCapacity: subStock.maxCapacity,
											lossRatio: subStock.lossRatio,
											averageConsumption: subStock.averageConsumption,
										}),
									)
									dispatch(stockParamsFormByStoreActions.showStockParamsByStoreForm())
								}}>
								Cập nhật
							</Button>
						</Box>
						<Typography sx={{ display: 'flex', alignItems: 'center' }}>
							<LabelIcon sx={{ fontSize: '16px', marginRight: '5px' }} /> Sức chứa tối đa:{' '}
							<span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{subStock?.maxCapacity} kg</span>
						</Typography>
						<Typography sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
							<LabelIcon sx={{ fontSize: '16px', marginRight: '5px' }} /> Tỉ lệ hao hụt:{' '}
							<span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{subStock?.lossRatio}%</span>
						</Typography>
						<Typography sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
							<LabelIcon sx={{ fontSize: '16px', marginRight: '5px' }} /> Mức tiêu thụ bình quân/ngày:{' '}
							<span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{subStock?.averageConsumption} kg</span>
						</Typography>
					</Box>
				</Card>
			</Box>
			<Box
				position='fixed'
				sx={{
					bottom: 0,
					left: mediaMd ? 300 : 0,
					right: 0,
				}}>
				{showParamsByStoreForm && currentUser.permission?.includes('manageStockByStore') && (
					<StockParamsByStoreForm getSubStock={getSubStock} />
				)}
			</Box>
		</UserLayout>
	)
}
